<nav class="sell-guide-steps__nav" aria-label="Home selling steps">
  @for (step of steps; track step.id) {
    <button
      type="button"
      class="sell-guide-steps__tab"
      [class.sell-guide-steps__tab--active]="activeStep() === step.id"
      [attr.aria-current]="activeStep() === step.id ? 'step' : null"
      (click)="selectStep(step.id)">
      <span class="sell-guide-steps__tab-num">{{ step.id }}</span>
      <span class="sell-guide-steps__tab-label">{{ step.shortTitle }}</span>
    </button>
  }
</nav>

<div class="sell-guide-steps__progress" role="presentation">
  <div
    class="sell-guide-steps__progress-fill"
    [style.width.%]="(activeStep() / steps.length) * 100"></div>
</div>

@for (step of steps; track step.id) {
  @if (activeStep() === step.id) {
    <article class="sell-guide-steps__panel">
      <div class="sell-guide-steps__media">
        <img
          [ngSrc]="step.image"
          width="960"
          height="540"
          [alt]="step.alt"
          class="sell-guide-steps__image">
        <span class="sell-guide-steps__badge">Step {{ step.id }} of {{ steps.length }}</span>
      </div>
      <div class="sell-guide-steps__copy">
        <h3 class="sell-guide-steps__title">{{ step.title }}</h3>
        <p class="sell-guide-steps__description">{{ step.description }}</p>
      </div>
    </article>
  }
}
